import { useEffect, useState } from 'react';

import type { RegionOption } from '../../../../shared/regionAccessOptions';
import {
  directorRegionsValid,
  regionChoicesFor,
  regionsAfterRoleChange,
} from '../director-regions';
import type { UserRoleId } from '../roleTaxonomy';

export interface AccessState {
  roleIds: UserRoleId[];
  regionIds: string[];
}

function setsEqual(a: string[], b: string[]): boolean {
  if (a.length !== b.length) return false;
  const sb = new Set(b);
  return a.every((x) => sb.has(x));
}

/** The Edit role modal's unsaved roles and regions, seeded from `initial` once it loads. */
export function useAccessDraft(
  initial: AccessState | null,
  regions: RegionOption[],
  userId: string,
) {
  const [roleIds, setRoleIds] = useState<UserRoleId[]>([]);
  const [regionIds, setRegionIds] = useState<string[]>([]);

  useEffect(() => {
    if (initial) {
      setRoleIds(initial.roleIds);
      setRegionIds(initial.regionIds);
    }
  }, [initial]);

  function changeRoles(ids: UserRoleId[]): void {
    setRoleIds(ids);
    setRegionIds((current) => regionsAfterRoleChange(ids, current, regions, userId));
  }

  return {
    roleIds,
    regionIds,
    changeRoles,
    changeRegions: setRegionIds,
    regionChoices: regionChoicesFor(roleIds, regions, userId),
    rolesChanged: initial ? !setsEqual(roleIds, initial.roleIds) : false,
    regionsChanged: initial ? !setsEqual(regionIds, initial.regionIds) : false,
    regionsFitRoles: directorRegionsValid(roleIds, regionIds),
  };
}
